import React from "react";
import Modal from "react-modal";
import "./CancellationPolicyModal.scss";
import IconClose from "venuescanner-js/react/components/Objects/Icons/IconCloseSvg";

Modal.setAppElement("#inbox");

const defaultModeratePolicy =
  "100% refund 30 days prior to the Event Date and 50% refund 14 days prior to the Event Date.";

export function CancellationPolicyModal({
  isModalOpen,
  closeModal,
  cancellationPolicy,
}) {
  return (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={closeModal}
      contentLabel="Cancellation Policy"
      className="cancellation-policy-modal__content"
      overlayClassName="cancellation-policy-modal__overlay"
    >
      <button
        className="cancellation-policy-modal__close-button"
        onClick={closeModal}
        type="button"
        aria-labelledby="cancellation-policy-close-label"
      >
        <span id="cancellation-policy-close-label" hidden>
          Close Cancellation Policy
        </span>
        <IconClose
          width="24px"
          height="24px"
          aria-hidden="true"
          focusable="false"
        />
      </button>
      <div>
        <h1 className="h3">Cancellation Policy</h1>
        <p className="cancellation-policy-modal__copy">
          {cancellationPolicy || defaultModeratePolicy}
        </p>
      </div>
    </Modal>
  );
}
